import { render, staticRenderFns } from "./h3-textarea.vue?vue&type=template&id=2c99a622&scoped=true&"
import script from "./h3-textarea.vue?vue&type=script&lang=ts&"
export * from "./h3-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./h3-textarea.vue?vue&type=style&index=0&id=2c99a622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99a622",
  null
  
)

export default component.exports